import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Layout from "./LayOut";
import Missing from "./pages/Missing";
import Verify from "./pages/Verify";
import RequireAuth from "./hooks/authenticate/RequireAuth";
// import RequireVerify from "./hooks/verify/RequireVerify";
// import Entry from "./pages/Entry";
import OnlineStats from "./pages/OnlineStats";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route
          element={<RequireAuth allowedRoles={["user", "admin", "owner"]} />}
        >
          <Route index element={<OnlineStats />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/register" element={<Register />} />
      </Route>
      {/* </Route> */}
      <Route path="*" element={<Missing />} />
      {/* </Route> */}
    </Routes>
  );
}

export default App;
